import { useBenchmarkHistory } from '@ui/services/pyth-benchmark/history/useBenchmarkHistory';

/**
 * the centralized hook to get price history of
 * - trading pair (TSLA/USD, BTC/USD, ...)
 */
export const usePriceHistory = useBenchmarkHistory;
